import { render, staticRenderFns } from "./Oleo100Preventive.vue?vue&type=template&id=5b2483d3&scoped=true"
import script from "./Oleo100Preventive.vue?vue&type=script&lang=js"
export * from "./Oleo100Preventive.vue?vue&type=script&lang=js"
import style0 from "./Oleo100Preventive.vue?vue&type=style&index=0&id=5b2483d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2483d3",
  null
  
)

export default component.exports